import UrlPattern from "url-pattern"

const URL_TOKEN_VALUE = "token="

export function route(pattern: string, path: string): null | any {
    let urlPattern = new UrlPattern(pattern)
    return urlPattern.match(path)
}

export function getUrlToken(): string {
    const uri = window.location.href
    const index = uri.trim().lastIndexOf(URL_TOKEN_VALUE)
    if (index > -1) {
        const token = window.location.href.substring(index + 6, uri.length)
        return token
    }
    return ""
}
